import { useEffect } from 'react'
import { useInputStore } from '../store/inputStore'
import { useHeadStore } from '../store/headStore'
import { useHandStore } from '../store/handStore'
import { useAppStore } from '../store/appStore'

/**
 * 全局键盘事件：
 * - 方向键：移动立方体位置（持续按住）
 * - R 重置立方体
 * - C 校准头部姿态
 * - Esc:
 *     - 抓取中：先释放
 *     - intro 视图：跳过到 lab
 *     - lab 视图：返回 intro
 */
export function KeyboardBindings() {
  useEffect(() => {
    const arrowMap: Record<string, keyof ReturnType<typeof useInputStore.getState>['arrowKeys']> = {
      ArrowLeft: 'left',
      ArrowRight: 'right',
      ArrowUp: 'up',
      ArrowDown: 'down',
    }

    const onKeyDown = (e: KeyboardEvent) => {
      // 方向键：不阻止重复事件，但只在首次按下时更新 store
      if (arrowMap[e.key]) {
        e.preventDefault()
        useInputStore.getState().setArrowKey(arrowMap[e.key], true)
        return
      }
      if (e.repeat) return
      switch (e.key) {
        case 'Escape': {
          const handPhase = useHandStore.getState().phase
          const view = useAppStore.getState().currentView
          if (handPhase === 'pinching') {
            useInputStore.getState().requestReleaseCube()
          } else if (view === 'intro') {
            useAppStore.getState().skipToLab()
          } else {
            useAppStore.getState().backToIntro()
          }
          break
        }
        case 'r':
        case 'R':
          useInputStore.getState().requestResetCube()
          break
        case 'c':
        case 'C':
          useHeadStore.getState().calibrate()
          break
      }
    }

    const onKeyUp = (e: KeyboardEvent) => {
      if (arrowMap[e.key]) {
        useInputStore.getState().setArrowKey(arrowMap[e.key], false)
      }
    }

    window.addEventListener('keydown', onKeyDown)
    window.addEventListener('keyup', onKeyUp)
    return () => {
      window.removeEventListener('keydown', onKeyDown)
      window.removeEventListener('keyup', onKeyUp)
    }
  }, [])
  return null
}
